module.exports = __webpack_public_path__ + "img/gold.9c37dac0.png";